// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import { MDBBtn } from "mdb-react-ui-kit";
// import axiosInstance from "../utilities/apiConfig";
// import Loader from "../components/Loader";
// import barLogo from "../assets/images/BarAssociationDeharadunLogo.png";
// import dummyProfileImage from "../assets/images/dummyPhoto.png";
// import dummySignature from "../assets/images/dummySignature.png";
// import dummyFingerprint from "../assets/images/dummyFingerPrint.jpg";
// import "../styles/welfareSlip.css";

// // SigCaptX-Utils.js (Wacom signature pad) overrides the global window.print
// // with its own print() that reads a DOM element's .value, which throws here.
// // We recover a clean native print() from a throwaway iframe so window.print()
// // on this page always uses the browser's real implementation.
// const nativePrint = () => {
//   try {
//     const iframe = document.createElement("iframe");
//     iframe.style.display = "none";
//     document.body.appendChild(iframe);
//     const framePrint = iframe.contentWindow.print;
//     document.body.removeChild(iframe);
//     // Call the untouched native print bound to the main window,
//     // so it prints the current document (not the iframe).
//     framePrint.call(window);
//   } catch (e) {
//     // Fallback: whatever window.print currently is.
//     window.print();
//   }
// };

// // Printable Welfare Fees Slip. Same layout as the FeesSlip.aspx report,
// // but rendered in-app with data from /Welfare/print_slip (welfare proc).
// const WelfareSlip = () => {
//   const { barId } = useParams(); // underscore format, e.g. "UK 1486_22"
//   const navigate = useNavigate();
//   const token = useSelector((state) => state.auth.token);

//   const [loading, setLoading] = useState(true);
//   const [slip, setSlip] = useState(null);
//   const [photo, setPhoto] = useState(dummyProfileImage);
//   const [signature, setSignature] = useState(dummySignature);
//   const [fingerprint, setFingerprint] = useState(dummyFingerprint);

//   // e.g. "Son" / "S/O" -> "Son of"
//   const relationshipLabel = (relationshipType) => {
//     const value = (relationshipType || "").toLowerCase();
//     if (value.includes("s")) return "Son of";
//     if (value.includes("d")) return "Daughter of";
//     if (value.includes("w")) return "Wife of";
//     return "Relative of";
//   };

//   // Loads an image through the File controller view apis
//   // (/File/view_photo, /File/view_signature, /File/view_fingerprint).
//   // slipData paths come as "Photo/abc.png" — only the file name is needed here.
//   const fetchImage = async (viewApi, relativePath, setImage, fallback) => {
//     const fileName = (relativePath || "").split("/").pop();
//     if (!fileName) {
//       setImage(fallback);
//       return;
//     }
//     try {
//       const response = await axiosInstance.get(
//         `/File/${viewApi}/${encodeURIComponent(fileName)}`,
//         {
//           responseType: "blob",
//         }
//       );
//       setImage(URL.createObjectURL(response.data));
//     } catch (error) {
//       console.error("Error fetching slip image:", relativePath, error);
//       setImage(fallback);
//     }
//   };

//   useEffect(() => {
//     const fetchSlipData = async () => {
//       try {
//         setLoading(true);
//         const response = await axiosInstance.get(
//           `/Welfare/print_slip/${barId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         console.log("Renewal/Verification slip response", response.data);

//         if (response.data?.response?.statusCode === 200) {
//           const slipData = response.data.slipData;
//           setSlip(slipData);
//           fetchImage("view_photo", slipData.photo, setPhoto, dummyProfileImage);
//           fetchImage(
//             "view_signature",
//             slipData.signature,
//             setSignature,
//             dummySignature
//           );
//           fetchImage(
//             "view_fingerprint",
//             slipData.fingerprintImage,
//             setFingerprint,
//             dummyFingerprint
//           );
//         } else {
//           toast.error(
//             response.data?.response?.status || "Could not load Renewal/Verification slip"
//           );
//         }
//       } catch (error) {
//         console.error("Error loading Renewal slip", error);
//         if (error.response?.status === 401) {
//           toast.error("Session expired. Please login again.");
//         } else {
//           toast.error("Could not load Renewal/Verification slip");
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSlipData();
//   }, [barId, token]);

//   const printDate = new Date().toLocaleString("en-GB", {
//     day: "2-digit",
//     month: "2-digit",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     hour12: true,
//   });

//   const amountText =
//     slip?.feesAmount !== null && slip?.feesAmount !== undefined
//       ? `₹${Number(slip.feesAmount).toLocaleString("en-IN", {
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2,
//         })}`
//       : "";

//   return (
//     <div className="welfare-slip-page">
//       {loading && <Loader />}

//       <div className="welfare-slip-actions">
//         <MDBBtn
//           color="secondary"
//           size="sm"
//           onClick={() => {
//             navigate("/WelfareFees");
//           }}
//         >
//           Back
//         </MDBBtn>
//         <MDBBtn
//           size="sm"
//           disabled={!slip}
//           onClick={() => {
//             nativePrint();
//           }}
//         >
//           Print
//         </MDBBtn>
//       </div>

//       <div className="welfare-slip-container">
//         <div className="welfare-slip-header">
//           <img src={barLogo} alt="Bar Association Dehradun" />
//           <h1>Dehradun Bar Association</h1>
//         </div>
//         <p className="welfare-slip-subtitle">Renewal/Verification Fees Slip</p>
//         {/* <p className="welfare-slip-date">Date: {printDate}</p> */}
//         <p className="welfare-slip-date">Date: {slip.entryDate}</p>

//         {slip ? (
//           <>
//             <div className="welfare-slip-details">
//               <img
//                 className="welfare-slip-photo"
//                 src={photo}
//                 alt="Advocate"
//               />
//               <div className="welfare-slip-fields">
//                 <div className="welfare-slip-field-row">
//                   <span className="welfare-slip-field-label">Name :</span>
//                   <span>{slip.name}</span>
//                 </div>
//                 <div className="welfare-slip-field-row">
//                   <span className="welfare-slip-field-label">
//                     {relationshipLabel(slip.relationshipType)} :
//                   </span>
//                   <span>{slip.relativeName}</span>
//                 </div>
//                 <div className="welfare-slip-field-row">
//                   <span className="welfare-slip-field-label">Bar Id :</span>
//                   <span>{slip.advocateBarId}</span>
//                 </div>
//                 <div className="welfare-slip-field-row">
//                   <span className="welfare-slip-field-label">Mobile No :</span>
//                   <span>{slip.mobileNo}</span>
//                 </div>
//               </div>
//             </div>

//             <table className="welfare-slip-table">
//               <thead>
//                 <tr>
//                   {slip.bookNo && <th>Book No</th>}
//                   {slip.srNo && <th>Serial No</th>}
//                   {slip.receiptNo && <th>Receipt No</th>}
//                   <th>Subscription Type</th>
//                   <th>Validity</th>
//                   <th>Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   {slip.bookNo && <td>{slip.bookNo}</td>}
//                   {slip.srNo && <td>{slip.srNo}</td>}
//                   {slip.receiptNo && <td>{slip.receiptNo}</td>}
//                   <td>{slip.memberType}</td>
//                   <td>{slip.validTill}</td>
//                   <td>{amountText}</td>
//                 </tr>
//               </tbody>
//             </table>

//             <div className="welfare-slip-footer">
//               <div className="footer-block">
//                 <span className="footer-label">Signature:</span>
//                 <img
//                   className="welfare-slip-signature"
//                   src={signature}
//                   alt="Signature"
//                 />
//               </div>
//               <div className="footer-block">
//                 <span className="footer-label">Fingerprint:</span>
//                 <img
//                   className="welfare-slip-fingerprint"
//                   src={fingerprint}
//                   alt="Fingerprint"
//                 />
//               </div>
//             </div>
//           </>
//         ) : (
//           !loading && (
//             <p className="text-center my-5">
//               No Renewal/Verification fee record found for this bar id.
//             </p>
//           )
//         )}
//       </div>
//     </div>
//   );
// };

// export default WelfareSlip;
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { MDBBtn } from "mdb-react-ui-kit";
import axiosInstance from "../utilities/apiConfig";
import Loader from "../components/Loader";
import barLogo from "../assets/images/BarAssociationDeharadunLogo.png";
import dummyProfileImage from "../assets/images/dummyPhoto.png";
import dummySignature from "../assets/images/dummySignature.png";
import dummyFingerprint from "../assets/images/dummyFingerPrint.jpg";
import "../styles/welfareSlip.css";

// SigCaptX-Utils.js (Wacom signature pad) overrides the global window.print
// with its own print() that reads a DOM element's .value, which throws here.
// We recover a clean native print() from a throwaway iframe so window.print()
// on this page always uses the browser's real implementation.
const nativePrint = () => {
  try {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    const framePrint = iframe.contentWindow.print;
    document.body.removeChild(iframe);
    // Call the untouched native print bound to the main window,
    // so it prints the current document (not the iframe).
    framePrint.call(window);
  } catch (e) {
    // Fallback: whatever window.print currently is.
    window.print();
  }
};

// entryDate comes from the welfare proc as an ISO-ish string,
// e.g. "2026-09-08T15:00:48.667" -> "08/09/2026 03:00:48 pm".
// Returns the raw value if it isn't parseable, and "" if it's missing.
const formatDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

// Printable Welfare Fees Slip. Same layout as the FeesSlip.aspx report,
// but rendered in-app with data from /Welfare/print_slip (welfare proc).
const WelfareSlip = () => {
  const { barId } = useParams(); // underscore format, e.g. "UK 1486_22"
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);

  const [loading, setLoading] = useState(true);
  const [slip, setSlip] = useState(null);
  const [photo, setPhoto] = useState(dummyProfileImage);
  const [signature, setSignature] = useState(dummySignature);
  const [fingerprint, setFingerprint] = useState(dummyFingerprint);

  // e.g. "Son" / "S/O" -> "Son of"
  const relationshipLabel = (relationshipType) => {
    const value = (relationshipType || "").toLowerCase();
    if (value.includes("s")) return "Son of";
    if (value.includes("d")) return "Daughter of";
    if (value.includes("w")) return "Wife of";
    return "Relative of";
  };

  // Loads an image through the File controller view apis
  // (/File/view_photo, /File/view_signature, /File/view_fingerprint).
  // slipData paths come as "Photo/abc.png" — only the file name is needed here.
  const fetchImage = async (viewApi, relativePath, setImage, fallback) => {
    const fileName = (relativePath || "").split("/").pop();
    if (!fileName) {
      setImage(fallback);
      return;
    }
    try {
      const response = await axiosInstance.get(
        `/File/${viewApi}/${encodeURIComponent(fileName)}`,
        {
          responseType: "blob",
        }
      );
      setImage(URL.createObjectURL(response.data));
    } catch (error) {
      console.error("Error fetching slip image:", relativePath, error);
      setImage(fallback);
    }
  };

  useEffect(() => {
    const fetchSlipData = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(
          `/Welfare/print_slip/${barId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("Renewal/Verification slip response", response.data);

        if (response.data?.response?.statusCode === 200) {
          const slipData = response.data.slipData;
          setSlip(slipData);
          fetchImage("view_photo", slipData.photo, setPhoto, dummyProfileImage);
          fetchImage(
            "view_signature",
            slipData.signature,
            setSignature,
            dummySignature
          );
          fetchImage(
            "view_fingerprint",
            slipData.fingerprintImage,
            setFingerprint,
            dummyFingerprint
          );
        } else {
          toast.error(
            response.data?.response?.status ||
              "Could not load Renewal/Verification slip"
          );
        }
      } catch (error) {
        console.error("Error loading Renewal slip", error);
        if (error.response?.status === 401) {
          toast.error("Session expired. Please login again.");
        } else {
          toast.error("Could not load Renewal/Verification slip");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchSlipData();
  }, [barId, token]);

  const amountText =
    slip?.feesAmount !== null && slip?.feesAmount !== undefined
      ? `₹${Number(slip.feesAmount).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : "";

  return (
    <div className="welfare-slip-page">
      {loading && <Loader />}

      <div className="welfare-slip-actions">
        <MDBBtn
          color="secondary"
          size="sm"
          onClick={() => {
            navigate("/WelfareFees");
          }}
        >
          Back
        </MDBBtn>
        <MDBBtn
          size="sm"
          disabled={!slip}
          onClick={() => {
            nativePrint();
          }}
        >
          Print
        </MDBBtn>
      </div>

      <div className="welfare-slip-container">
        <div className="welfare-slip-header">
          <img src={barLogo} alt="Bar Association Dehradun" />
          <h1>Dehradun Bar Association</h1>
        </div>
        <p className="welfare-slip-subtitle">Renewal/Verification Fees Slip</p>

        {slip ? (
          <>
            <p className="welfare-slip-date">
              Date: {formatDateTime(slip.entryDate)}
            </p>

            <div className="welfare-slip-details">
              <img className="welfare-slip-photo" src={photo} alt="Advocate" />
              <div className="welfare-slip-fields">
                <div className="welfare-slip-field-row">
                  <span className="welfare-slip-field-label">Name :</span>
                  <span>{slip.name}</span>
                </div>
                <div className="welfare-slip-field-row">
                  <span className="welfare-slip-field-label">
                    {relationshipLabel(slip.relationshipType)} :
                  </span>
                  <span>{slip.relativeName}</span>
                </div>
                <div className="welfare-slip-field-row">
                  <span className="welfare-slip-field-label">Bar Id :</span>
                  <span>{slip.advocateBarId}</span>
                </div>
                <div className="welfare-slip-field-row">
                  <span className="welfare-slip-field-label">Mobile No :</span>
                  <span>{slip.mobileNo}</span>
                </div>
              </div>
            </div>

            <table className="welfare-slip-table">
              <thead>
                <tr>
                  {slip.bookNo && <th>Book No</th>}
                  {slip.srNo && <th>Serial No</th>}
                  {slip.receiptNo && <th>Receipt No</th>}
                  <th>Subscription Type</th>
                  <th>Validity</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {slip.bookNo && <td>{slip.bookNo}</td>}
                  {slip.srNo && <td>{slip.srNo}</td>}
                  {slip.receiptNo && <td>{slip.receiptNo}</td>}
                  <td>{slip.memberType}</td>
                  <td>{slip.validTill}</td>
                  <td>{amountText}</td>
                </tr>
              </tbody>
            </table>

            <div className="welfare-slip-footer">
              <div className="footer-block">
                <span className="footer-label">Signature:</span>
                <img
                  className="welfare-slip-signature"
                  src={signature}
                  alt="Signature"
                />
              </div>
              <div className="footer-block">
                <span className="footer-label">Fingerprint:</span>
                <img
                  className="welfare-slip-fingerprint"
                  src={fingerprint}
                  alt="Fingerprint"
                />
              </div>
            </div>
          </>
        ) : (
          !loading && (
            <p className="text-center my-5">
              No Renewal/Verification fee record found for this bar id.
            </p>
          )
        )}
      </div>
    </div>
  );
};

export default WelfareSlip;